module.exports = __webpack_public_path__ + "static/media/logo-horizontal-white2.84f5b138.svg";